
/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
import { Sortable, Plugins } from '@shopify/draggable';

/*------------------------------------*\
    REORDER MODULE
\*------------------------------------*/
class Reorder {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
      let self = this;

      self.populateReorderList();

      const containerSelector = '.draggable-list .draggable-list__stacked';
      const containers = document.querySelectorAll(containerSelector);
      const order = [];
    
      if (containers.length === 0) {
        return false;
      }
    
      const sortable = new Sortable(containers, {
        draggable: '.draggable-list__stacked--is-draggable',
        mirror: {
          appendTo: containerSelector,
          xAxis: false
        },
        //plugins: [Plugins.Snappable]
      });

      sortable.on('sortable:stop', (e) => {
        // Reset order array to reorder values on drag
        order.length = 0;

        sortable.getDraggableElementsForContainer(e.newContainer).forEach((draggableElement, index) => {
          let choiceField = draggableElement.getElementsByClassName('choice-field')[0];
          choiceField.value = index + 1; // Set 1 as minimum value
          
          // Push values to array
          order.push({"key": choiceField.name, "label": choiceField.dataset.label});
        });

        // Set order array as value in local storage
        // Set field values from parent container
        localStorage.setItem(
          e.newContainer.dataset.field,
          JSON.stringify({
              'label': e.newContainer.dataset.label,
              'value': order
          })
        );

      });
    
      return sortable;
    }

    populateReorderList() {
      let self = this;
      let reorder = document.getElementsByClassName('draggable-list__stacked')[0]
      let field = JSON.parse(localStorage.getItem('15-question'));

      // If exists, loop through array
      if(field && field.value.length) {
        // Empty markup from parent container before populating
        $('.draggable-list__stacked').empty();

        field.value.forEach(row => {
          // Create the markup for row
          let markup = `
            <div class="draggable-list__stacked--is-draggable">
              <div>
                <input type="hidden" class="choice-field" name="${row.key}" data-label="${row.label}" />
                ${row.label}
              </div>
              <span class="draggable-list__icon"></span>
            </div>
          `;

          // Insert the table row inside the table body
          reorder.insertAdjacentHTML('beforeend', markup);
        });
      }
  }
}

export default Reorder;